const state = {
	orgId: '',
	orgName: '',
	location: '',
	//buyer: {'name': '', 'phone': '', 'state': ''},
	payment: {'paidTotal': 0, 'paidCash': 0, 'paidBank': 0, 
			  'returned': 0, 'outstanding': 0, 'discount': 0, 'surcharge': 0, 
			  'invoiceIssued': 'No', 'invoiceNbr': '', 'GSTN': '', 'invoiceDate': new Date(), 'note': '',
			  'serviceTicket': '', 'serviceCost': 0}
}

const mutations = {
	'UPDATE_ORG_ID' (state, orgId) {
		state.orgId = orgId
	},
	'UPDATE_ORG_NAME' (state, orgName) {
		state.orgName = orgName
	},
	'UPDATE_LOCATION' (state, location) {
		state.location = location
	},
	'UPDATE_PAYMENT' (state, payment) {
		state.payment = payment
	},
	'CLEAR_PAYMENT' (state) {
		state.payment.paidTotal = 0
		state.payment.paidCash = 0
		state.payment.paidBank = 0
		state.payment.returned = 0
		state.payment.outstanding = 0
		state.payment.discount = 0
		state.payment.surcharge = 0
		state.payment.invoiceIssued = 'No'
		state.payment.invoiceNbr = ''
		state.payment.GSTN = ''
		state.payment.note = ''
		state.payment.serviceTicket = ''
		state.payment.serviceCost = 0
	},
}

const actions = {
	setOrgId: ({commit}, {orgId}) => {
		commit('UPDATE_ORG_ID', orgId);
	},
	setOrgName: ({commit}, {orgName}) => {
		commit('UPDATE_ORG_NAME', orgName);
	},
	setLocation: ({commit}, {location}) => {
		commit('UPDATE_LOCATION', location);
	},
	setPayment: ({commit}, {payment}) => {
		commit('UPDATE_PAYMENT', payment);
	},
	clearPayment: ({commit}) => {
		commit('CLEAR_PAYMENT', []);
	}
}

const getters = {
	orgId: (state) => {
		return state.orgId;
	},
	orgName: (state) => {
		return state.orgName;
	},
	location: (state) => {
		return state.location;
	},
	// buyer: (state) => {
	// 	return state.buyer;
	// },
	payment: (state) => {
		return state.payment;
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}